import type { ReactNode } from 'react';
import styles from './VisuallyHidden.module.css';

/**
 * **視覚には出さず、読み上げには届ける。**
 *
 * **色と形の二重符号（§5.5）でも、色も形も視覚にしか届かない。**
 * 状態名を文字で添えるための部品である。
 *
 * **`display: none` は使えない** — 読み上げからも消える。
 */
export function VisuallyHidden({ children }: { readonly children: ReactNode }): ReactNode {
  return <span className={styles['hidden']}>{children}</span>;
}
